import React, { useState, useEffect } from 'react';
import { storage } from '../firebase'; // Ensure Firebase is initialized
import { ref, getDownloadURL } from 'firebase/storage';
import DOMPurify from 'dompurify';

const ReviewText = ({ reviewId }) => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const storageRef = ref(storage, `matchmedic_reviews/${reviewId}.html`);
        const url = await getDownloadURL(storageRef);
        const response = await fetch(url);
        const htmlContent = await response.text();
        
        // Parse sections using regex
        const sectionRegex = /\[(-?\d+)\](.*?)(?=\[(-?\d+)\]|<\/body>|$)/gs;
        const matches = [...htmlContent.matchAll(sectionRegex)];
        
        const parsedSections = matches.map(([full, days, content]) => {
          const titleNumber = parseInt(days);
          let title;
          
          // Handle special cases first
          if (titleNumber === 0) {
            title = "Procedure Day Update";
          } else if (titleNumber === -1) {
            title = "Pre-Procedure Day Update";
          } else {
            // Original logic for other numbers
            title = titleNumber < 30 
              ? `Day-${titleNumber} Update` 
              : `${Math.floor(titleNumber/30)}-Month Update`;
          }
          
          return {
            title,
            content: content.trim()
          };
        });

        setSections(parsedSections);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchReview();
  }, [reviewId]);

  if (loading) return <div>Loading review...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="bg-white py-6 px-4 rounded-b-lg shadow-md max-w-5xl mx-auto lg:mb-10">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">
        Review Updates
      </h2>
      {sections.map((section, index) => (
        <div key={index} className="pb-2 w-full p-6">
          <h3 className="text-xl font-medium text-gray-700 mb-3">
            {section.title}
          </h3>
          <div 
            className="text-gray-600 prose text-justify break-words overflow-x-auto max-w-full"            dangerouslySetInnerHTML={{ 
              __html: DOMPurify.sanitize(section.content) 
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default ReviewText;